<template>
  <div class="header">
    <div class="headercenter" @click="goHome">
      <img src="@/assets/login.png" class="logmng" />
      <div>{{biaoTi}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      biaoTi: localStorage.getItem('biaoti'),
    };
  },
  methods: {
    goHome() {
      // 如果为个人中心的页面点击返回主页，不是则返回上一页
      if (this.$route.matched[0].path == '/personCenter') {
        this.$router.push('/home');
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped>
.header {
  height: 60px;
  background-color: rgba(50, 65, 96, 1);
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 1px;
}
.headercenter {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.logmng {
  height: 40px;
  width: 40px;
  margin-right: 10px;
}
</style>



